import { render, staticRenderFns } from "./Lenders.vue?vue&type=template&id=7374f350&"
import script from "./Lenders.vue?vue&type=script&lang=js&"
export * from "./Lenders.vue?vue&type=script&lang=js&"
import style0 from "./Lenders.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports